export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-pound-ddc757ad2064211f6e02777ad66509bc.svg";